//Module Keys
let locales = {};

//Merge Views
import keysFobsTab from 'Modules/keysFobs/.components/tab/lan/es';
import keysFobsMain from '../../views/main/lan/es';
import createEditKeyFob from 'Modules/keysFobs/.components/createEditKeyFob/lan/es';
import deleteKeyFob from 'Modules/keysFobs/.components/deleteKeyFob/lan/es';
import bulkAddDriverIdTags from 'Modules/keysFobs/.components/bulkAddDriverIdTags/lan/es';
import moveToAnotherAccount from 'Modules/keysFobs/.components/moveToAnotherAccount/lan/es';
import unassignDrivers from 'Modules/keysFobs/.components/unassignDrivers/lan/es';

locales = { 
    ...locales,
    ...keysFobsTab,
    ...keysFobsMain,
    ...createEditKeyFob,
    ...deleteKeyFob,
    ...bulkAddDriverIdTags,
    ...moveToAnotherAccount,
    ...unassignDrivers,
};

export default locales;